import { faMapMarkerAlt } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type TProps = {
  lat: number
  lng: number
  label: string
}

const Marker: React.FC<TProps> = () => {
  return (
    <div className="bg-red-500 w-8 h-8 flex justify-center items-center rounded-full text-white opacity-90 absolute inset-1/2">
      <FontAwesomeIcon icon={faMapMarkerAlt} size={'2x'} />
    </div>
  )
}

export default Marker
